






































































































































































import Vue from 'vue'
import VueRouter from 'vue-router'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { HeaderMap } from '@/constants/personalBook'
import { MetaInfo } from 'vue-meta/types/vue-meta'

export default Vue.extend({
  name: 'PersonalBookCover',
  data () {
    return {
      hasError: false,
      isLoading: false,
      isEnableValidation: false,
      bookInfo: {
        name: '' as string,
        faceType: 0,
        traitSelected: '00000000',
        materialSelected: 0,
        cover: 2,
        backgroundSelected: 0,
        message: '' as string,
        imagePath: '' as string
      },
      coverType: [
        '夥伴款',
        '夥伴防疫款',
        '恐龍款',
        '精靈花園款'
      ],
      coverText: '' as string,
      coverOptions: [
      ] as string[],
      coverCarouselImage: [
      ] as string[]
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: '封面選擇',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  computed: {
    screenAspectRatio (): number {
      return window.screen.width / window.screen.height
    },
    traitSelectedCount (): number {
      let num = 0
      for (const item of this.bookInfo.traitSelected) {
        if (item === '1') {
          num++
        }
      }
      return num
    }
  },
  created () {
    postAppMessage(MessageHandlers.UPDATE_HEADER, HeaderMap.COVER)
    window.navigateBack = () => this.$router.go(-1)
    this.loadBookInfoFromLocalStorage()
    this.setCoverImage()
  },
  methods: {
    validateName (target: string | number | null | undefined) {
      if (this.isEnableValidation) {
        if (target === null || target === undefined) {
          this.hasError = true
          return false
        }
        // Chinese+English+Number+_ : [1,8] / except Chinese: [1,12]
        if (typeof (target) === 'string' && (!target.match(/^[\u4E00-\u9FA5a-zA-Z0-9_]{1,8}$/) && !target.match(/^[a-zA-Z0-9_]{1,12}$/))) {
          this.hasError = true
          return false
        }
        return true
      }
      return null
    },
    validateTrait () {
      if (this.isEnableValidation) {
        if (this.traitSelectedCount !== 4) {
          this.hasError = true
          return false
        }
        return true
      }
      return null
    },
    onCoverClicked (index: number) {
      if (index < 0) return
      this.bookInfo.cover = index
      this.coverText = this.coverType[index]
      this.saveBookInfoToLocalStorage()
    },
    saveBookInfoToLocalStorage () {
      localStorage.setItem('bookInfo', JSON.stringify({
        name: this.bookInfo.name,
        faceType: this.bookInfo.faceType || 0,
        traitSelected: this.bookInfo.traitSelected,
        materialSelected: this.bookInfo.materialSelected || 0,
        cover: this.bookInfo.cover === undefined ? 2 : this.bookInfo.cover,
        backgroundSelected: this.bookInfo.backgroundSelected || 0,
        message: this.bookInfo.message,
        imagePath: this.bookInfo.imagePath
      }))
    },
    loadBookInfoFromLocalStorage () {
      const dataString = localStorage.getItem('bookInfo') || ''
      if (dataString) {
        const data = JSON.parse(dataString)
        if (data.name.length === 0 || data.traitSelected.length === 0 || data.traitSelected === '00000000') {
          this.$router.replace({ name: 'PersonalBook' })
        }
        this.bookInfo.name = data.name
        this.bookInfo.faceType = data.faceType
        this.bookInfo.traitSelected = data.traitSelected
        this.bookInfo.materialSelected = data.materialSelected
        this.bookInfo.cover = data.cover
        this.bookInfo.backgroundSelected = data.backgroundSelected
        this.bookInfo.message = data.message
        this.bookInfo.imagePath = data.imagePath
        this.coverText = this.coverType[this.bookInfo.cover]
      } else {
        this.$router.replace({ name: 'PersonalBook' })
      }
    },
    setCoverImage () {
      this.coverOptions.push('https://nuphoto.com.tw/personalbook/assets/cover_option0_' + this.bookInfo.faceType + '.jpg')
      this.coverOptions.push('https://nuphoto.com.tw/personalbook/assets/cover_option1_' + this.bookInfo.faceType + '.jpg')
      this.coverOptions.push('https://nuphoto.com.tw/personalbook/assets/cover_option2_' + this.bookInfo.faceType + '.jpg')
      this.coverOptions.push('https://nuphoto.com.tw/personalbook/assets/cover_option3_' + this.bookInfo.faceType + '.jpg')
      this.coverCarouselImage.push('https://nuphoto.com.tw/personalbook/assets/preview/cover_pre0_' + this.bookInfo.faceType + '.jpg')
      this.coverCarouselImage.push('https://nuphoto.com.tw/personalbook/assets/preview/cover_pre1_' + this.bookInfo.faceType + '.jpg')
      this.coverCarouselImage.push('https://nuphoto.com.tw/personalbook/assets/preview/cover_pre2_' + this.bookInfo.faceType + '.jpg')
      this.coverCarouselImage.push('https://nuphoto.com.tw/personalbook/assets/preview/cover_pre3_' + this.bookInfo.faceType + '.jpg')
    },
    onNextClicked () {
      const pre = [
        'https://nuphoto.com.tw/personalbook/assets/background_option0_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_option1_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_option2_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_option3_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_img0_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_img1_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_img2_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_img3_' + this.bookInfo.faceType + '.jpg'
      ]

      const imageContainer = document.getElementById('image-container')
      for (const i in pre) {
        let preImg = document.getElementById('pb-img' + i) as HTMLImageElement
        if (!preImg) {
          console.log('createElement')
          preImg = document.createElement('img')
          preImg.id = 'pb-img' + i
          if (imageContainer) {
            imageContainer.appendChild(preImg)
          }
        }
        preImg.src = pre[i]
      }

      setTimeout(() => {
        for (const i in pre) {
          const preImg = document.getElementById('pb-img' + i) as HTMLImageElement
          if (preImg) {
            if (!preImg.complete) {
              this.onNextClicked()
              return
            }
          }
        }

        if (imageContainer) {
          imageContainer.innerHTML = ''
        }

        this.$router.push({ name: 'PersonalBook2', query: this.$route.query })
        this.isEnableValidation = false
        this.isLoading = false
      }, 250)
    }
  }
})
